import { useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { postRequestContact } from "../apis/requestContact";

export const useSubmitRequestContact = () => {
  return useMutation(postRequestContact, {
    onSuccess: (res) => {
      // console.log("onSuccess res");
    },
    onMutate: async (data: any) => {
      /**Optimistic mutation */
    },
    onError: (_err, data, context) => {
      // console.log("Please try again");
    },
  });
};

export const useShowSuccessToast = () => {
  const toast = useToast();

  const showSuccessToast = (message: string) => {
    toast({
      position: "top",
      title: "Your mail has been sent.",
      description: message,
      status: "success",
      duration: 10000,
      isClosable: true,
    });
  };

  return showSuccessToast;
};

export const useShowErrorToast = () => {
  const toast = useToast();

  const showErrorToast = (message: string) => {
    toast({
      position: "top",
      title: "Something went wrong.",
      description: message,
      status: "error",
      duration: 10000,
      isClosable: true,
    });
  };

  return showErrorToast;
};
